<app-modal
	*ngIf="vo$ | async; let vo"
	class="app-internal-metadata">

		<app-internal-metadata-config
			modal-body
			[internalMetadata]="vo.internalMetadata"
			[isInViewMode]="false"
			(hasInternalMetadataChanged)="internalMetadataChanged()"></app-internal-metadata-config>


	<div modal-footer class="app-internal-metadata__footer">
		<div
			*ngIf="vo.error"
			class="error-alert error">
			<mat-icon
				[ngClass]="{ 'warning': vo.error.type === 'warning' }"
				color="warn"
				[svgIcon]="vo.error.type === 'critic'? DcIcons.Error: DcIcons.Warning"></mat-icon>
			<span>{{vo.error.message}}</span>
		</div>

		<button
			id="{{ cmpId }}-update-btn"
			color="primary"
			mat-raised-button
			[disabled]="!vo.isValid"
			(click)="updateAction()">
			<span i18n="@@general.action.edit">update</span>
		</button>
	</div>
</app-modal>
